import { createIcon } from '../icon'
import SlippersIcon from '../svg/SlippersIcon'

export const SlippersIconDefault = createIcon(SlippersIcon)
